// Angular
import { Component, Input, OnInit } from '@angular/core';
import { Auth, Cache } from 'aws-amplify';
import { Router } from '@angular/router';

@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
	styles: [
		'.btn-outline-brand {color: black;border-color: black;}',
		'.btn-outline-brand:hover {background-color: black;color: white}',
	]
})
export class UserProfileComponent implements OnInit {

	user$ = { fullname: 'Patrick Jane'};
	userAttr: Record<string, string>;

	@Input() avatar = false;
	@Input() greeting = true;
	@Input() badge = true;
	@Input() icon: boolean;

	constructor(private router: Router) {}

	ngOnInit(): void {
		const userAttr = Cache.getItem('userAttr') as Record<string, string> | null;
		if (!userAttr) {
			this.logout();
			return;
		}
		this.userAttr = userAttr;
		this.user$.fullname = (userAttr.given_name || '') + ' ' + (userAttr.family_name || '');
	}

	logout() {
		Auth.signOut();
		Cache.clear();
		this.router.navigate(['login']);
	}

	onListClick(option) {
		switch (option) {
			case 'profile':
				this.router.navigate(['user-settings', 'profile']);
				break;
			case 'notification':
				this.router.navigate(['user-settings', 'notification']);
				break;
			default:
				break;
		}
	}
}
